import { CreateAccountSelector } from './CreateAccount';
export default CreateAccountSelector;
